import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { gql, useQuery } from '@apollo/client';
import { ALL, APOLLO_GRAPHQL_CLIENT_NAME, APOLLO_STUDIO_EXPLORER, CONTENTFUL_PREVIEW_ACCESS_TOKEN, EVICT_CACHE, NO_CACHE, USE_CACHE } from '../constants';
import { logGQLErrors } from '../logGQLErrors';
import { getDefaultNavMenu } from '../navigationMenu';
import { formatOneGraphData } from '../navigationMenuParser';
import { getOneGraphQuery } from '../operations';
import { getOneGraphClient } from '../client';
/**
 * useNavigationData hook is used to extract NaigationMenu Data from DIPL-LPC-DGS repo
 * @param {skipQuery} boolean.
 * @returns data , loadingState
 */

export var useNavigationData = function useNavigationData(_ref) {
  var _objectSpread2, _formatOneGraphData;

  var _ref$skipQuery = _ref.skipQuery,
      skipQuery = _ref$skipQuery === void 0 ? false : _ref$skipQuery,
      navigationDataType = _ref.navigationDataType,
      clientEnv = _ref.clientEnv,
      locale = _ref.locale,
      _ref$useCache = _ref.useCache,
      useCache = _ref$useCache === void 0 ? true : _ref$useCache,
      _ref$isPreviewMode = _ref.isPreviewMode,
      isPreviewMode = _ref$isPreviewMode === void 0 ? false : _ref$isPreviewMode,
      accessToken = _ref.accessToken,
      countryCode = _ref.countryCode,
      navigationName = _ref.navigationName,
      _ref$evictCache = _ref.evictCache,
      evictCache = _ref$evictCache === void 0 ? false : _ref$evictCache,
      _ref$device = _ref.device,
      device = _ref$device === void 0 ? 'desktop' : _ref$device,
      oneGraphClient = _ref.oneGraphClient;

  var headers = _objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, APOLLO_GRAPHQL_CLIENT_NAME, APOLLO_STUDIO_EXPLORER), _defineProperty(_objectSpread2, USE_CACHE, useCache), _objectSpread2), evictCache && _defineProperty({}, EVICT_CACHE, 'true')), accessToken && isPreviewMode && _defineProperty({}, CONTENTFUL_PREVIEW_ACCESS_TOKEN, accessToken));

  var _getOneGraphQuery = getOneGraphQuery(navigationDataType),
      query = _getOneGraphQuery.query;

  var gqlQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), query);
  var client = oneGraphClient || getOneGraphClient(clientEnv);

  var _useQuery = useQuery(gqlQuery, {
    client: client,
    variables: {
      locale: locale,
      navigationName: navigationName,
      countryCode: countryCode
    },
    context: {
      headers: headers
    },
    // skips query if props are provided or if global locales are not fetched
    skip: skipQuery,
    errorPolicy: ALL,
    fetchPolicy: NO_CACHE,
    ssr: true
  }),
      loading = _useQuery.loading,
      respData = _useQuery.data,
      error = _useQuery.error;

  var isLoading = !skipQuery && loading;

  if (error) {
    var defaultnav = getDefaultNavMenu({
      navigationDataType: navigationDataType,
      navigationName: navigationName,
      locale: locale,
      countryCode: countryCode
    });
    logGQLErrors("Navigation Data fetching error - ".concat(navigationDataType).concat(locale ? "/".concat(locale) : '').concat(countryCode ? "/".concat(countryCode) : ''), error);
    return {
      data: defaultnav.navigationMenu,
      isLoading: isLoading
    };
  } //If navigtionMenu is present means it is bff query and if not means it's a onegraph query and we need to reformat it to old version.


  var componentData = (respData === null || respData === void 0 ? void 0 : respData.navigationMenu) || ((_formatOneGraphData = formatOneGraphData(respData)) === null || _formatOneGraphData === void 0 ? void 0 : _formatOneGraphData.navigationMenu);
  return {
    data: (componentData === null || componentData === void 0 ? void 0 : componentData[device]) || (componentData === null || componentData === void 0 ? void 0 : componentData['desktop']) || componentData,
    isLoading: isLoading
  };
};